import { GroupFolderId } from './types';

export function getGroupFolderKey(deviationId: number, { groupId, type, folderId }: GroupFolderId) {
  return `${deviationId}:${groupId}:${type}:${folderId}`;
}

export function getGroupsStreamId() {
  return 'groups';
}

export function getFolderStreamId(type: string, groupId: number) {
  return `folders:${groupId}:${type}`;
}
